import styled from 'styled-components';
import { media } from 'designsystem/index';

const CurrentImageWrapper = styled.div`
  width: 100%;
  position: relative;
  overflow: hidden;
  height: 365px;

  ${media.desktop`
    height: 515px;
  `}
`;

export default CurrentImageWrapper;



// WEBPACK FOOTER //
// ./src/kentico-blocks/ImageSlider/ImageSlide/CurrentImageWrapper.jsx